/**
 * Standalone event-type literal union shared by the metadata catalog
 * (`event-metadata.ts`), the extractor (`extract-payload.ts`), and the
 * supported-events public surface (`supported-events.ts`). Lives in
 * its own file so `event-metadata.ts` doesn't have to import from
 * `supported-events.ts` (which itself depends on `event-metadata.ts`)
 * — that loop is harmless for type-only consumers but error-prone for
 * future runtime additions.
 *
 * Adding a new event: push the literal here, then add a metadata
 * entry in `event-metadata.ts` and an extractor branch in
 * `extract-payload.ts`.
 */
export const SUPPORTED_CLERK_EVENTS = [
  'user.created',
  'organization.created',
  'organizationInvitation.created',
  'organizationInvitation.accepted',
  'organizationInvitation.revoked',
  'organizationMembership.created',
  'paymentAttempt.created',
  'subscription.created',
  'subscriptionItem.freeTrialEnding',
  'subscriptionItem.pastDue',
  'subscriptionItem.canceled',
  'subscriptionItem.abandoned',
  'waitlistEntry.created',
] as const

export type SupportedClerkEventType = (typeof SUPPORTED_CLERK_EVENTS)[number]

export const SUPPORTED_CLERK_EVENT_SET = new Set<string>(SUPPORTED_CLERK_EVENTS)
